import "@main/styles/global.css"
import { startMSW } from "./src/mswInit"
import { DynamicRecaptchaProvider } from "./src/presentation/shared/components/wrapper-recaptcha/WrapperRecaptcha"

import { RootElement } from "./src/root"

export const wrapRootElement = ({ element }) => {
  startMSW()

  return (
    <RootElement>
      <DynamicRecaptchaProvider>
        {element}
      </DynamicRecaptchaProvider>
    </RootElement>
  )
}

export const onClientEntry = () => {
  if (
    process.env.GATSBY_MAINTENANCE === "1" &&
    !window.location.pathname.includes("/mantenimiento")
  ) {
    window.location.href = "/mantenimiento"
  }
}
